import { Component, OnInit } from "@angular/core";

import { getAccountName } from "../../util";
import { BrowserTitleService } from "../../common/browser-title/browser-title.service";
import { TranslateService } from "../../common/translate/translate.service";
import { environment } from "environments/environment";
import { SnackbarService } from "app/common/snackbar/snackbar.service";

@Component({
	selector: "sdp-client-download",
	templateUrl: "./client-download.component.html"
})
export class ClientDownloadComponent implements OnInit {
	public downloadUrl: string;
	public emailUrl = "";
	public demoSite = "";
	public readonly linkIcon = { type: "material", name: "link", cssClass: "sdp-access-section-right-side-icon" };
	public readonly downloadIcon = { type: "material", name: "file_download", cssClass: "sdp-access-section-right-side-icon" };
	public readonly emailIcon = { type: "material", name: "email", cssClass: "sdp-access-section-right-side-icon" };
	public readonly copyIcon = { type: "material", name: "content_copy", cssClass: "sdp-access-section-right-side-icon" };

	constructor(
		private titleService: BrowserTitleService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService
	) {
		this.downloadUrl = environment.DOWNLOAD_SITE;
		this.demoSite = environment.DEMO_SITE;
	}

	public get emailBody() {
		return this.translateService.translate("download.email.template.body", {
			downloadUrl: environment.DOWNLOAD_SITE,
			accountName: getAccountName()
		});
	}

	public get emailSubject() {
		return this.translateService.translate("download.email.template.subject");
	}

	public async ngOnInit() {
		this.titleService.setTitle("client-download.header.title");
		this.emailUrl = `mailto:?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;
	}

	public loadEmailUrl() {
		window.location.href = this.emailUrl;
	}

	public openDemoSite() {
		window.open(this.demoSite, "_blank");
	}

	public openDownloadSite() {
		window.open(this.downloadUrl, "_blank");
	}

	public copied() {
		this.snackbarService.open(this.translateService.translate("copy.email.template.toastr"));
	}

}
